import { graphql } from 'gatsby';
import SEO from '@components/Common/SEO/index';
import '@fortawesome/fontawesome-svg-core/styles.css';
import React from 'react';
import Navigation from '@components/NavigationV2/index';
import FooterV2 from '@components/FooterV2/index';
import CrackedCrioCareersSection from '@components/v5/CrackedCrioCareersSection/index';
import ProjectsSection from '@components/v5/ProjectsSection/index';
import RoundedLayout from '@components/v5/layouts/RoundedLayout/index';
import VideoTestimonialSection from '@components/v5/VideoTestimonialSection/index';
import CrioComparisionSection from '@components/v5/CrioComparisionSection/index';
import Testimonial from '@components/v5/Testimonial/index';
import FAQSection from '@components/v5/FAQSection/index';
// import StepsSection from '@components/v5/StepsSection/index';
import WhyCrioSection from '@components/v5/WhyCrioSection/index';
import CrioButton from '@components/v5/CrioButton/index';
import PostContentCTALayout from '@components/v5/layouts/PostContentCTALayout/index';
import { Link } from 'gatsby';
import { ERoutes } from '@src/constants/routes/index';
import { EProgramIDs } from '@src/constants/data/programs/index';
import SaleMiddleStrip from '@components/v5/Sale/SaleMiddleStrip';
import { stripData } from '@components/Sale/data';
import { PPCStylePageHero } from '@components/v5/FspStylePageHero/index';
import StatsPanelFSP from '@components/v5/StatsPanelFSP/index';
import FspCurriculumSection from '@components/v5/FspCurriculumSection/index';
import FspPricingCardSection from '@components/v5/FspPricingCardSection/index';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import {
  LEAD_GEN_HOME_PROJECTS,
  LEAD_GEN_FLOATING_CTA,
  LEAD_GEN_DEVELOPERS_CRACKED,
  LEAD_GEN_WHY_CRIO,
  LEAD_GEN_PROJECTS,
  LEAD_GEN_CURRICULUM,
  // LEAD_GEN_PROGRAM_STEPS,
  LEAD_GEN_CAREER_ASSISTANCE,
  LEAD_GEN_TESTIMONIALS,
  LEAD_GEN_CRIO_COMPARISION,
  LEAD_GEN_FAQ,
  LEAD_GEN_CURRICULUM_PRICING_CARD,
  LEAD_GEN_PLAN_SECTION,
} from '../constants/LeadGenerationConstants/index';
import ScrollButtonComponent from '@components/ScrollButtonComponent/index';
import { useWebEngage } from '@src/hooks/useWebEngage';
import PersonalizedPlan from '@components/v5/PersonalizedPlan/index';
import useCrioStat from '@src/hooks/useCrioStats';

export default function PPCStylePage(props) {
  const { captureUserClickEvent } = useWebEngage();

  const { placementStats } = useCrioStat();

  const onPlacementButtonClick = () => {
    captureUserClickEvent('Get our Placement Stats', {
      placementLocation: 'PPC_PAGE',
    });
  };
  const { data: queryData } = props;
  const { ppcStylePagesYaml: data } = queryData;
  const program = props.data.allStrapiPrograms.nodes.find(
    (ele) => ele.PrimaryProgramID == data.PrimaryProgramID,
  );

  const sale = props.data.strapiSale.SaleID;

  const getProjectsSectionPreContent = (sale) => {
    switch (sale) {
      case 'true':
        return (
          <div className="mx-4 mb-10 flex justify-center">
            <SaleMiddleStrip data={stripData[program.PrimaryProgramID]}>
              <LeadGenerationButton
                type="Apply & Start Free"
                buttonLocation={LEAD_GEN_HOME_PROJECTS}
              />
            </SaleMiddleStrip>
          </div>
        );

      default:
        return <></>;
    }
  };

  return (
    <div>
      <SEO
        title={data.SEOTitle}
        description={data.SEODescription}
        canonicalUrl={data.canonicalUrl}
      ></SEO>
      <ScrollButtonComponent
        component={
          <LeadGenerationButton
            type="Apply & Start Free"
            buttonLocation={LEAD_GEN_FLOATING_CTA}
          />
        }
        startAt={600}
      ></ScrollButtonComponent>
      <Navigation
        dark
        program={program.PrimaryProgramID}
        sale={sale}
      ></Navigation>
      <div className="bg-v5-green-700">
        <div className="text-v5-neutral-300">
          <PPCStylePageHero
            program={program}
            title={data.heroTitle}
            image={data.heroImage.childImageSharp}
            description={data.heroDescription}
            stats={[]}
            statsSubtitle={data.statsSubtitle}
            sale={sale}
          ></PPCStylePageHero>
        </div>
        <WhyCrioSection
          dark
          heading={data.highlightsTitle}
          description={data.highlightsDescription}
          quote={data.highlightsQuote}
          data={data.highlights}
          postContent={
            <PostContentCTALayout>
              <LeadGenerationButton
                type="Apply & Start Free"
                buttonLocation={LEAD_GEN_WHY_CRIO}
              />
            </PostContentCTALayout>
          }
        ></WhyCrioSection>

        <CrackedCrioCareersSection
          dark
          postContent={
            <PostContentCTALayout>
              <div>
                <div className="-mb-10">
                  <StatsPanelFSP
                    stats={placementStats.map((stat) => {
                      return {
                        title: stat.content,
                        subtitle: `${stat.label}`,
                      };
                    })}
                    dark
                  ></StatsPanelFSP>
                </div>
                <PostContentCTALayout className="mb-10">
                  <Link to={ERoutes.PLACEMENTS}>
                    <CrioButton
                      variant="secondary"
                      onClick={onPlacementButtonClick}
                      className="h-[64px] w-[300px] border-white py-6 text-white sm:w-auto"
                    >
                      Get our Placement Stats
                    </CrioButton>
                  </Link>
                  <LeadGenerationButton
                    type="Apply & Start Free"
                    className="h-[64px] w-[300px]"
                    buttonLocation={LEAD_GEN_DEVELOPERS_CRACKED}
                  />
                </PostContentCTALayout>
              </div>
            </PostContentCTALayout>
          }
        ></CrackedCrioCareersSection>

        <RoundedLayout
          roundedBg="bg-v5-green-700"
          className="bg-white text-black"
          both
        >
          <div className="min-h-[800px] py-10">
            <ProjectsSection
              heading={data.projectsTitle}
              description={data.projectsDescription}
              projects={data.projects}
              postContent={
                <PostContentCTALayout>
                  <LeadGenerationButton
                    type="Apply & Start Free"
                    buttonLocation={LEAD_GEN_PROJECTS}
                  />
                </PostContentCTALayout>
              }
              preContent={getProjectsSectionPreContent(sale)}
            ></ProjectsSection>
          </div>
        </RoundedLayout>
        <div className="mt-10">
          <FspCurriculumSection
            dark
            heading={data.curriculumTitle}
            description={data.curriculumDescription}
            quote={data.curriculumQuote}
            type={data.PrimaryProgramID}
            curriculum={data.curriculum}
            advancedCurriculum={data.advancedCurriculum}
            dreamCompanies={data.dreamCompanies}
            superDreamCompanies={data.superDreamCompanies}
            postContent={
              <PostContentCTALayout>
                <LeadGenerationButton
                  type="Apply & Start Free"
                  buttonLocation={LEAD_GEN_CURRICULUM}
                />
              </PostContentCTALayout>
            }
          ></FspCurriculumSection>
        </div>

        <PersonalizedPlan
          postContent={
            <LeadGenerationButton
              type="Download"
              text="Apply & Start For Free"
              buttonLocation={LEAD_GEN_PLAN_SECTION}
            />
          }
        />

        <WhyCrioSection
          dark
          heading={data.careerTitle}
          description={data.careerDescription}
          data={data.careers}
          postContent={
            <PostContentCTALayout>
              <LeadGenerationButton
                type="Apply & Start Free"
                buttonLocation={LEAD_GEN_CAREER_ASSISTANCE}
              />
            </PostContentCTALayout>
          }
        ></WhyCrioSection>
        <FspPricingCardSection
          dark
          price={data.price}
          duration={data.priceDuration}
          sale={sale}
          program={program.PrimaryProgramID}
          postContent={
            <PostContentCTALayout>
              <LeadGenerationButton
                type="Apply & Start Free"
                buttonLocation={LEAD_GEN_CURRICULUM_PRICING_CARD}
              />
            </PostContentCTALayout>
          }
        ></FspPricingCardSection>
        {/* <StepsSection
          data={data.steps}
          dark
          postContent={
            <PostContentCTALayout>
              <LeadGenerationButton
                type="Apply & Start Free"
                buttonLocation={LEAD_GEN_PROGRAM_STEPS}
              />
            </PostContentCTALayout>
          }
        ></StepsSection> */}
        <VideoTestimonialSection
          dark
          quote={data.testimonialQuote}
          disableCareerHandbook={
            data.PrimaryProgramID === EProgramIDs.QA_AUTOMATION_TESTING
          }
          postContent={
            <PostContentCTALayout>
              <div className="-mt-16 xxs:-mt-10 sm:-mt-0">
                <LeadGenerationButton
                  type="Apply & Start Free"
                  buttonLocation={LEAD_GEN_TESTIMONIALS}
                />
              </div>
            </PostContentCTALayout>
          }
        ></VideoTestimonialSection>
        <RoundedLayout roundedBg="bg-white" className="bg-v5-green-700" bottom>
          <CrioComparisionSection
            dark
            postContent={
              <div className="-mt-12">
                <PostContentCTALayout>
                  <LeadGenerationButton
                    type="Apply & Start Free"
                    buttonLocation={LEAD_GEN_CRIO_COMPARISION}
                  />
                </PostContentCTALayout>
                <div className="container mt-16">
                  <div className="flex flex-col gap-x-10 md:flex-row">
                    <Testimonial dark></Testimonial>
                  </div>
                </div>
              </div>
            }
          ></CrioComparisionSection>
        </RoundedLayout>
      </div>
      <RoundedLayout
        roundedBg="bg-v5-green-100"
        className="bg-white pb-16"
        bottom
      >
        <FAQSection
          data={data.faqs}
          postContent={
            <PostContentCTALayout>
              <LeadGenerationButton
                type="Apply & Start Free"
                buttonLocation={LEAD_GEN_FAQ}
              />
            </PostContentCTALayout>
          }
        ></FAQSection>
      </RoundedLayout>
      <FooterV2></FooterV2>
    </div>
  );
}

export const pageQuery = graphql`
  query ($id: String!) {
    ppcStylePagesYaml(id: { eq: $id }) {
      PrimaryProgramID
      slug
      canonicalUrl
      SEOTitle
      SEODescription
      heroTitle
      heroDescription
      heroImage {
        childImageSharp {
          gatsbyImageData(
            width: 750
            quality: 100
            blurredOptions: {}
            placeholder: NONE
            formats: [AUTO, WEBP]
          )
        }
      }

      statsSubtitle

      highlightsTitle
      highlights {
        description
        image {
          childImageSharp {
            gatsbyImageData(
              width: 200
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }

      projectsTitle
      projectsDescription

      careerTitle
      careerDescription
      careers {
        description
        image {
          childImageSharp {
            gatsbyImageData(
              width: 200
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }

      curriculumTitle
      curriculumDescription
      curriculumQuote

      dreamCompanies {
        image {
          childImageSharp {
            gatsbyImageData(
              width: 300
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
        originalImage {
          childImageSharp {
            gatsbyImageData(
              width: 300
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
      superDreamCompanies {
        image {
          childImageSharp {
            gatsbyImageData(
              width: 300
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
        originalImage {
          childImageSharp {
            gatsbyImageData(
              width: 300
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
      curriculum {
        title
        image {
          childImageSharp {
            gatsbyImageData(
              width: 100
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
        duration
        tag
        data
        skills
        anchor
        cardTitle
        cards {
          image {
            childImageSharp {
              gatsbyImageData(
                width: 300
                quality: 100
                blurredOptions: {}
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
          data
          skills
          title
        }
      }
      advancedCurriculum {
        title
        image {
          childImageSharp {
            gatsbyImageData(
              width: 100
              quality: 100
              blurredOptions: {}
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
        duration
        tag
        data
        skills
        cardTitle
        cards {
          image {
            childImageSharp {
              gatsbyImageData(
                width: 300
                quality: 100
                blurredOptions: {}
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
          data
          skills
          title
        }
      }

      steps

      price
      priceDuration

      faqs {
        question
        answer
      }
    }

    allStrapiPrograms {
      ...allStrapiProgramsFragment
    }

    ...strapiDataFragment
  }
`;
